/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_New_BadgeInputs */

const en_merge_event_group_new_badge = /** @type {(inputs: Merge_Event_Group_New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

const fr_merge_event_group_new_badge = /** @type {(inputs: Merge_Event_Group_New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau`)
};

const de_merge_event_group_new_badge = /** @type {(inputs: Merge_Event_Group_New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu`)
};

const it_merge_event_group_new_badge = /** @type {(inputs: Merge_Event_Group_New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo`)
};

const ru_merge_event_group_new_badge = /** @type {(inputs: Merge_Event_Group_New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новый`)
};

const es_merge_event_group_new_badge = /** @type {(inputs: Merge_Event_Group_New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo`)
};

const zh_cn2_merge_event_group_new_badge = /** @type {(inputs: Merge_Event_Group_New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新的`)
};

const ja_merge_event_group_new_badge = /** @type {(inputs: Merge_Event_Group_New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい`)
};

const hi_merge_event_group_new_badge = /** @type {(inputs: Merge_Event_Group_New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया`)
};

const pt_pt2_merge_event_group_new_badge = /** @type {(inputs: Merge_Event_Group_New_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo`)
};

/**
* | output |
* | --- |
* | "New" |
*
* @param {Merge_Event_Group_New_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_new_badge = /** @type {((inputs?: Merge_Event_Group_New_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_New_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_event_group_new_badge(inputs)
	if (locale === "de") return de_merge_event_group_new_badge(inputs)
	if (locale === "it") return it_merge_event_group_new_badge(inputs)
	if (locale === "ru") return ru_merge_event_group_new_badge(inputs)
	if (locale === "es") return es_merge_event_group_new_badge(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_event_group_new_badge(inputs)
	if (locale === "ja") return ja_merge_event_group_new_badge(inputs)
	if (locale === "hi") return hi_merge_event_group_new_badge(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_event_group_new_badge(inputs)
	return en_merge_event_group_new_badge(inputs)
});